export default {
  ENQUEUE_SNACKBAR: "meta/ENQUEUE_SNACKBAR",
  REMOVE_SNACKBAR: "meta/REMOVE_SNACKBAR",
};
